import { REAL_ESTATE_TYPES, REAL_ESTATE_USAGES } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../utils/regex.utils';
import { schemaBigDecimal, schemaInteger } from '../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#immobilie

	{
        "antragstellerIds": [ String ],
        "bezeichnung": String,<
        "darlehen": [
            {
                "restschuld": BigDecimal,
                "zinsbindungBis": "YYYY-MM-DD",
                "rateMonatlich": BigDecimal
            }
        ],
        "immobilienart": "EIGENTUMSWOHNUNG" | "EINFAMILIENHAUS" | "MEHRFAMILIENHAUS" | "BUEROGEBAEUDE",
        "mieteinnahmenKaltMonatlich": BigDecimal,
        "mieteinnahmenWarmMonatlich": BigDecimal,
        "nebenkostenMonatlich": BigDecimal,
        "nutzungsart": "EIGENGENUTZT" | "VERMIETET" | "EIGENGENUTZT_UND_VERMIETET",
        "vermieteteWohnflaeche": Integer,
        "wert": BigDecimal,
        "wohnflaeche": Integer
    }

*/
export const schemaEuropaceUpdateImmobilie = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    bezeichnung: z.optional(z.string()),
    darlehen: z.optional(
        z.array(
            z.object({
                rateMonatlich: z.optional(schemaBigDecimal),
                restschuld: z.optional(schemaBigDecimal),
                zinsbindungBis: z.optional(z.string().regex(regex_iso_date)),
            }),
        ),
    ),
    immobilienart: z.optional(z.nativeEnum(REAL_ESTATE_TYPES)),
    mieteinnahmenKaltMonatlich: z.optional(schemaBigDecimal),
    mieteinnahmenWarmMonatlich: z.optional(schemaBigDecimal),
    nebenkostenMonatlich: z.optional(schemaBigDecimal),
    nutzungsart: z.optional(z.nativeEnum(REAL_ESTATE_USAGES)),
    vermieteteWohnflaeche: z.optional(schemaInteger),
    wert: z.optional(schemaBigDecimal),
    wohnflaeche: z.optional(schemaInteger),
});

export type SchemaEuropaceUpdateImmobilie = z.infer<typeof schemaEuropaceUpdateImmobilie>;
